function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M49.05 17.8c.38-.28.95-.01.95.44v19.04c0 2.47-2.1 4.47-4.69 4.47H4.7c-2.59 0-4.69-2-4.69-4.47V18.25c0-.46.56-.72.95-.44C3.13 19.43 6.04 21.5 16 28.4c2.06 1.43 5.53 4.45 9 4.43 3.49.03 7.03-3.05 9.01-4.43 9.96-6.9 12.86-8.97 15.04-10.59zM25 29.83c2.27.04 5.53-2.72 7.17-3.85C45.13 17 46.1 16.23 49.1 14c.57-.42.9-1.07.9-1.76v-1.77C50 8 47.9 6 45.31 6H4.7C2.1 6 0 8 0 10.47v1.77c0 .69.33 1.33.9 1.76C3.89 16.22 4.87 17 17.83 25.98c1.64 1.13 4.9 3.9 7.17 3.85z"
})));